import { render, staticRenderFns } from "./qs4-08.vue?vue&type=template&id=a3073720&"
import script from "./qs4-08.vue?vue&type=script&lang=js&"
export * from "./qs4-08.vue?vue&type=script&lang=js&"
import style0 from "./qs4-08.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports